module.exports = __webpack_public_path__ + "img/goto_btn.a62c7a1e.png";